import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = {
  class: "tab-content",
  id: "myTabContent4"
}
const _hoisted_4 = {
  class: "tab-pane fade",
  id: "code4-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "code4-tab",
  tabindex: "0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "fs-18 mb-4" }, "BG Outline Alerts", -1)),
      _cache[4] || (_cache[4] = _createElementVNode("ul", {
        class: "nav nav-tabs mb-4",
        id: "myTab4",
        role: "tablist"
      }, [
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link active",
            id: "preview4-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#preview4-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "preview4-tab-pane",
            "aria-selected": "true"
          }, " Preview ")
        ]),
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link",
            id: "code4-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#code4-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "code4-tab-pane",
            "aria-selected": "false"
          }, " Code ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", {
          class: "tab-pane fade show active",
          id: "preview4-tab-pane",
          role: "tabpanel",
          "aria-labelledby": "preview4-tab",
          tabindex: "0"
        }, [
          _createElementVNode("div", {
            class: "alert alert-primary text-primary",
            role: "alert"
          }, [
            _createTextVNode(" A simple primary alert with "),
            _createElementVNode("a", {
              href: "#",
              class: "fw-semibold"
            }, "an example link"),
            _createTextVNode(". Give it a click if you like. ")
          ]),
          _createElementVNode("div", {
            class: "alert alert-secondary text-secondary",
            role: "alert"
          }, [
            _createTextVNode(" A simple secondary alert with "),
            _createElementVNode("a", {
              href: "#",
              class: "fw-semibold"
            }, "an example link"),
            _createTextVNode(". Give it a click if you like. ")
          ]),
          _createElementVNode("div", {
            class: "alert alert-success text-success",
            role: "alert"
          }, [
            _createTextVNode(" A simple success alert with "),
            _createElementVNode("a", {
              href: "#",
              class: "fw-semibold"
            }, "an example link"),
            _createTextVNode(". Give it a click if you like. ")
          ]),
          _createElementVNode("div", {
            class: "alert alert-danger text-danger",
            role: "alert"
          }, [
            _createTextVNode(" A simple danger alert with "),
            _createElementVNode("a", {
              href: "#",
              class: "fw-semibold"
            }, "an example link"),
            _createTextVNode(". Give it a click if you like. ")
          ]),
          _createElementVNode("div", {
            class: "alert alert-warning text-warning",
            role: "alert"
          }, [
            _createTextVNode(" A simple warning alert with "),
            _createElementVNode("a", {
              href: "#",
              class: "fw-semibold"
            }, "an example link"),
            _createTextVNode(". Give it a click if you like. ")
          ]),
          _createElementVNode("div", {
            class: "alert alert-info text-info",
            role: "alert"
          }, [
            _createTextVNode(" A simple info alert with "),
            _createElementVNode("a", {
              href: "#",
              class: "fw-semibold"
            }, "an example link"),
            _createTextVNode(". Give it a click if you like. ")
          ]),
          _createElementVNode("div", {
            class: "alert alert-light text-light",
            role: "alert"
          }, [
            _createTextVNode(" A simple light alert with "),
            _createElementVNode("a", {
              href: "#",
              class: "fw-semibold"
            }, "an example link"),
            _createTextVNode(". Give it a click if you like. ")
          ]),
          _createElementVNode("div", {
            class: "alert alert-dark text-dark mb-0",
            role: "alert"
          }, [
            _createTextVNode(" A simple dark alert with "),
            _createElementVNode("a", {
              href: "#",
              class: "fw-semibold"
            }, "an example link"),
            _createTextVNode(". Give it a click if you like. ")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyCode && _ctx.copyCode(...args)))
          }, " Copy "),
          _cache[1] || (_cache[1] = _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
            _createTextVNode(""),
            _createElementVNode("code", {
              class: "language-markup",
              id: "basicAlertsCode4"
            }, "\n<div class=\"alert alert-primary text-primary\" role=\"alert\">\n  A simple primary alert with <a href=\"#\" class=\"fw-semibold\">an example link</a>. Give it a click if you like.\n</div>\n<div class=\"alert alert-secondary text-secondary\" role=\"alert\">\n  A simple secondary alert with <a href=\"#\" class=\"fw-semibold\">an example link</a>. Give it a click if you like.\n</div>\n<div class=\"alert alert-success text-success\" role=\"alert\">\n  A simple success alert with <a href=\"#\" class=\"fw-semibold\">an example link</a>. Give it a click if you like.\n</div>\n<div class=\"alert alert-danger text-danger\" role=\"alert\">\n  A simple danger alert with <a href=\"#\" class=\"fw-semibold\">an example link</a>. Give it a click if you like.\n</div>\n<div class=\"alert alert-warning text-warning\" role=\"alert\">\n  A simple warning alert with <a href=\"#\" class=\"fw-semibold\">an example link</a>. Give it a click if you like.\n</div>\n<div class=\"alert alert-info text-info\" role=\"alert\">\n  A simple info alert with <a href=\"#\" class=\"fw-semibold\">an example link</a>. Give it a click if you like.\n</div>\n<div class=\"alert alert-light text-light\" role=\"alert\">\n  A simple light alert with <a href=\"#\" class=\"fw-semibold\">an example link</a>. Give it a click if you like.\n</div>\n<div class=\"alert alert-dark text-dark mb-0\" role=\"alert\">\n  A simple dark alert with <a href=\"#\" class=\"fw-semibold\">an example link</a>. Give it a click if you like.\n</div>\n"),
            _createTextVNode("\n")
          ], -1))
        ])
      ])
    ])
  ]))
}